module.exports = __webpack_public_path__ + "/login_ui/img/bd-98d594fde1bbf2f1620905787b857272.svg";